export const defaultLocation = {
    locationName: '',
    address: '',
    phoneNumber: '',
    comments: '',
    createTime: '',
    updateTime: '',
}
